import { format } from "date-fns";
import { applyMask } from "../../../utils";
import { Patient } from "../../../services/patient.service";

export const phoneMask = applyMask("phone");

export const formatPatientDate = (value?: string): string => {
  if (!value) return "—";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? "—" : format(d, "dd/MM/yyyy");
};

/** Data da última consulta REAL do paciente (mais recente em consultations[]); cai p/ o campo manual se não houver. */
export const lastConsultationDate = (patient: Pick<Patient, "consultations" | "consultationDate">): string | undefined => {
  const dates = (patient.consultations ?? []).map((c) => c.date).filter(Boolean);
  if (dates.length === 0) return patient.consultationDate;
  return dates.reduce((latest, d) => (new Date(d).getTime() > new Date(latest).getTime() ? d : latest));
};

/** Normaliza um telefone para o formato aceito pelo wa.me (só dígitos, com DDI 55 do Brasil). */
export const normalizeWhatsappPhone = (phone?: string): string => {
  const trimmed = (phone || "").trim();
  if (!trimmed) return "";

  const digitsOnly = trimmed.replace(/\D/g, "");
  if (!digitsOnly) return "";

  if (trimmed.startsWith("+")) return digitsOnly;
  if (trimmed.startsWith("00")) return digitsOnly.replace(/^00/, "");
  if (digitsOnly.startsWith("55")) return digitsOnly;
  return `55${digitsOnly}`;
};

/** URL do wa.me para o telefone, ou "" se inválido. */
export const whatsappUrl = (phone?: string): string => {
  const normalized = normalizeWhatsappPhone(phone);
  return normalized ? `https://wa.me/${normalized}` : "";
};
